module.exports = __webpack_public_path__ + "img/zhengzaidaoru.5342dde0.png";